<!-- =========================================================================================
    File Name: TableDefault.vue
    Description: Rendering default table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card no-shadow>
		<vs-table @selected="handleSelected" v-model="selected" pagination max-items="10" search :data="sessionsApi">
			<template slot="header">
				<h3>Tokens</h3>
			</template>

			<template slot="thead">
				<vs-th sort-key="id">N</vs-th>
				<vs-th sort-key="email" colspan="1">Token</vs-th>
				<vs-th sort-key="website"></vs-th>
				<vs-th sort-key="email">{{ $t("Email") }}</vs-th>
				<vs-th sort-key="username">{{ $t("Username") }}</vs-th>
				<vs-th sort-key="website">{{ $t("SessionApi.ExpireDate") }}</vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
					<vs-td :data="indextr + 1">
						{{ indextr + 1 }}
					</vs-td>

					<vs-td :data="data[indextr].access_token" v-model="data[indextr].access_token">
						{{ data[indextr].access_token }}
					</vs-td>

					<vs-td class="whitespace-no-wrap">
						<div class="flex flex-row">
							<vx-tooltip delay=".1s" :text="$t('SessionApi.Copy') + ' ' + 'token'" position="left">
								<feather-icon
									v-show="selected && selected.access_token === data[indextr].access_token"
									icon="CopyIcon"
									svgClasses="w-5 h-5 hover:text-success stroke-current"
									class="mr-2"
									v-clipboard:copy="data[indextr].access_token"
									v-clipboard:success="onCopy"
									v-clipboard:error="onError"
								/>
							</vx-tooltip>
							<vx-tooltip delay=".1s" :text="$t('UploadFiles.Download') + ' ' + 'token'" position="left">
								<feather-icon
									v-show="selected && selected.access_token === data[indextr].access_token"
									icon="DownloadIcon"
									svgClasses="w-5 h-5 hover:text-success stroke-current"
									class="ml-2"
									@click="handleOption('EXPORT')"
								/>
							</vx-tooltip>
						</div>
					</vs-td>

					<vs-td :data="data[indextr].email">
						{{ data[indextr].email }}
					</vs-td>

					<vs-td :data="data[indextr].username">
						{{ data[indextr].username }}
					</vs-td>

					<vs-td :data="data[indextr].expire_token">
						{{ data[indextr].expire_token }}
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</vx-card>
</template>

<script>
import moduleSessionApi from "@/store/session-api/moduleSessionApi";
import vSelect from "vue-select";

export default {
	components: {
		vSelect,
	},
	props: {
		handleItemSelected: {
			type: Function,
		},
		clearSelectionTrigger: {
			type: Number,
		},
		handleOption: {
			type: Function,
			required: false,
		},
	},
	data: () => ({
		selected: null,
	}),
	computed: {
		sessionsApi() {
			return this.$store.getters["moduleSessionApi/getAllSessions"]();
		},
	},
	methods: {
		handleSelected(tr) {
			this.handleItemSelected(tr);
		},
		async getSessions() {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			const companyId = this.$route.params.id ? this.$route.params.id : +userInfo.serviroutes_company_id;
			try {
				if (userInfo.serviroutes_role_name === "GOTU")
					await this.$store.dispatch("moduleSessionApi/getSessionsApiByCompany", companyId);
				else await this.$store.dispatch("moduleSessionApi/getSessionsApi");
			} catch (error) {
				console.error(error);
			}
		},
		onCopy() {
			this.$vs.notify({
				title: this.$t("SessionApi.Copied"),
				text: this.$t("SessionApi.CopiedText"),
				color: "success",
				iconPack: "feather",
				icon: "icon-check-circle",
			});
		},
		onError() {
			this.$vs.notify({
				title: this.$t("ErrorTitle"),
				text: this.$t("ErrorInCopying"),
				color: "danger",
				iconPack: "feather",
				icon: "icon-alert-circle",
			});
		},
	},
	watch: {
		clearSelectionTrigger(val) {
			this.selected = null;
		},
	},
	created() {
		if (!moduleSessionApi.isRegistered) {
			this.$store.registerModule("moduleSessionApi", moduleSessionApi);
			moduleSessionApi.isRegistered = true;
		}
		this.getSessions();
	},
};
</script>
